export default "__VITE_ASSET__CSdzwuoA__"